import api from '../api';

const path = '/sell/car';
const pathPro = '/sell/pro/car';

export const addCarRequest = (values) => api.post(`${path}/add`, values);
export const deleteCarRequest = (id) => api.delete(`${path}/delete/${id}`);
export const getCarRequest = (id) => api.get(`${path}/get/${id}`);
export const getCarListRequest = (params) => api.get(`${path}/get`, { params });
export const editCarRequest = (updates) =>
    api.put(`${path}/edit/${updates.id}`, {
        updates,
    });
export const updateCarRequest = (updates) =>
    api.put(`${path}/update/${updates.id}`, updates);

export const addCarProRequest = (values) => api.post(`${pathPro}/add`, values);
export const editCarProRequest = (updates) =>
    api.put(`${pathPro}/edit/${updates.id}`, {
        updates,
    });
